import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShipmentWaybillDemurrageAndDetentionInfoService } from './shipment-waybill-demurrage-and-detention-info.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import {
  ShipmentWaybillDemurrageAndDetentionInfoLoad,
  ShipmentWaybillDemurrageAndDetentionInfoSetInitialState,
} from './shipment-waybill-demurrage-and-detention-info.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import {
  ShipmentWaybillDemurrageAndDetention,
  ShipmentWaybillDemurrageAndDetentionContainer,
  ShipmentWaybillDemurrageAndDetentionSummary,
} from '../../models';

export interface ShipmentWaybillDemurrageAndDetentionInfoStateModel {
  demurrageAndDetention: ShipmentWaybillDemurrageAndDetention;
  loaded: boolean;
}

const initialState: ShipmentWaybillDemurrageAndDetentionInfoStateModel = {
  demurrageAndDetention: null,
  loaded: false,
};

@State<ShipmentWaybillDemurrageAndDetentionInfoStateModel>({
  name: 'shipmentWaybillDemurrageAndDetentionInfo',
  defaults: initialState,
})
@Injectable()
export class ShipmentWaybillDemurrageAndDetentionInfoState {
  constructor(
    private shipmentLoadOverviewService: ShipmentWaybillDemurrageAndDetentionInfoService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getLoaded(state: ShipmentWaybillDemurrageAndDetentionInfoStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getSummary(
    state: ShipmentWaybillDemurrageAndDetentionInfoStateModel,
  ): ShipmentWaybillDemurrageAndDetentionSummary {
    return state.demurrageAndDetention.summary;
  }

  @Selector()
  static getDestination(
    state: ShipmentWaybillDemurrageAndDetentionInfoStateModel,
  ): ShipmentWaybillDemurrageAndDetentionContainer {
    return state.demurrageAndDetention.destination;
  }

  @Selector()
  static getOrigin(
    state: ShipmentWaybillDemurrageAndDetentionInfoStateModel,
  ): ShipmentWaybillDemurrageAndDetentionContainer {
    return state.demurrageAndDetention.origin;
  }

  @Action(ShipmentWaybillDemurrageAndDetentionInfoLoad)
  getDemurrageAndDetentionInfo(
    ctx: StateContext<ShipmentWaybillDemurrageAndDetentionInfoStateModel>,
    { payload }: ShipmentWaybillDemurrageAndDetentionInfoLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentLoadOverviewService.getInfoData(payload).pipe(
      map((demurrageAndDetention: ShipmentWaybillDemurrageAndDetention) => {
        ctx.patchState({ demurrageAndDetention, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillDemurrageAndDetentionInfoSetInitialState)
  setInitialState(ctx: StateContext<ShipmentWaybillDemurrageAndDetentionInfoStateModel>): void {
    ctx.setState(initialState);
  }
}
